export default class Tel {

static getHolderSelectors = () => ['a[href^="tel:"]'];

	/**
	 *
	 * @param {HTMLAnchorElement} holderElement
	 */
	constructor(holderElement) {
		holderElement.href = holderElement.href.replaceAll(/[\s()]/g, '');
	}

}
